import logo from './logo.svg';
import './App.css';
import 'survey-core/defaultV2.min.css';
import "survey-core/survey.i18n";
import { useCallback } from 'react';
import { Model } from 'survey-core';
import { Survey } from 'survey-react-ui';
import axios from "axios";


const surveyJson = {
  "locale": "zh-cn",
  "title": "学校信息收集",
  "description": "请输入贵校基本信息",
  "completedHtml": "<h3>信息已经提交，谢谢！</h3>",
  "completedHtmlOnCondition": [
    {
      "html": "<h3>信息已经提交，谢谢！</h3> "
    },
    {
      "html": "<h3>信息已经提交，谢谢！</h3> "
    }
  ],
  "pages": [
    {
      "name": "info",
      "elements": [
        {
          "type": "text",
          "name": "school",
          "title": {
            "zh-cn": "1 学校名称："
          },
          "isRequired": true
        },
        {
          "type": "text",
          "name": "name",
          "title": {
            "zh-cn": "2 联系人姓名："
          },
          "isRequired": true
        },
        {
          "type": "text",
          "name": "phone",
          "title": {
            "zh-cn": "3 联系人手机号码（用于系统登录）："
          },
          "isRequired": true
        },
        {
          "type": "text",
          "name": "password",
          "title": {
            "zh-cn": "4 登录密码："
          },
          "isRequired": true
        },
        {
          "type": "comment",
          "name": "schoolinfo",
          "title": {
            "zh-cn": "5 学校简介："
          },
          "isRequired": true
        },
        {
          "type": "radiogroup",
          "name": "schooltype",
          "title": {
            "zh-cn": "6 学校类型："
          },
          "isRequired": true,
          "choices": [
            {
              "value": "公办",
              "text": {
                "zh-cn": "公办"
              }
            },
            {
              "value": "民办",
              "text": {
                "zh-cn": "民办"
              }
            }
          ]
        },
        {
          "type": "radiogroup",
          "name": "gradetype",
          "title": {
            "zh-cn": "7 学段类型："
          },
          "isRequired": true,
          "choices": [
            {
              "value": "小学",
              "text": {
                "zh-cn": "小学"
              }
            },
            {
              "value": "初中",
              "text": {
                "zh-cn": "初中"
              }
            },
            {
              "value": "高中",
              "text": {
                "zh-cn": "高中"
              }
            },
            {
              "value": "小学加初中",
              "text": {
                "zh-cn": "小学加初中"
              }
            },
            {
              "value": "初中加高中",
              "text": {
                "zh-cn": "初中加高中"
              }
            },
            {
              "value": "小学加初中加高中",
              "text": {
                "zh-cn": "小学加初中加高中"
              }
            }
          ]
        },
        {
          "type": "text",
          "name": "num",
          "title": {
            "zh-cn": "8 学校人数："
          },
          "isRequired": true
        },
        {
          "type": "text",
          "name": "address",
          "title": {
            "zh-cn": "9 学校所在地址，请具体到镇街："
          },
          "isRequired": true
        }
      ],
      "questionTitleLocation": "top",
      "questionsOrder": "initial",
      "navigationButtonsVisibility": "show"
    }
  ],
  "showQuestionNumbers": "off"
}

async function saveSurveyResults(url, json) {
  try {
    const response = await axios.post(url + '/api/school', json);
    debugger;
    alert(response.data.message);
  } catch (error) {
    debugger;
    console.error("Error adding school:", error.response.data);
  }
}


function App() {
  const survey = new Model(surveyJson);

  const surveyComplete = useCallback((sender) => {
    saveSurveyResults(
        "../addschooldb/public",
        sender.data
    )
  }, []);

  survey.onComplete.add(surveyComplete);

  return (
    <div>
      <Survey model={survey} />;
    </div>
  );
}

export default App;
